import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classNames from 'classnames';
import { SelectPopupOption } from './selectPopupOption';
import { ensureChildrenVisibility } from './utils/ensureChildrenVisibility';
import * as styles from './selectPopup.css';
export var SelectPopup = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectPopup, _React$Component);

  var _super = _createSuper(SelectPopup);

  function SelectPopup(props) {
    var _this;

    _classCallCheck(this, SelectPopup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "focusedOptionRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "setFocusedOptionState", function (selected) {
      var focusedIndex = _this.state.focusedIndex;

      if (focusedIndex >= 0) {
        _this.props.setOptionState(focusedIndex, selected);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFocusedOptionState", function () {
      var focusedIndex = _this.state.focusedIndex;

      if (focusedIndex >= 0) {
        _this.props.toggleOptionState(focusedIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "moveFocusIndex", function (delta) {
      var current = _this.state.focusedIndex;
      var next = current + delta;

      if (current === -1) {
        next = 0;
      }

      if (next < 0 || next >= _this.props.options.length) {
        return;
      }

      _this.setState({
        focusedIndex: next
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOptionClick", function (_, index) {
      if (_this.props.multiple) {
        _this.props.toggleOptionState(index);
      } else {
        _this.props.setOptionState(index, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMoveOption", function (_, index) {
      if (_this.state.focusedIndex === index) {
        return;
      }

      _this.setState({
        focusedIndex: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isSelectedOption", function (option) {
      var value = _this.props.value;

      if (Array.isArray(value)) {
        return value.includes(option.value);
      }

      return value === option.value;
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedOptionIndex", function () {
      if (_this.props.multiple) {
        return -1;
      }

      return _this.props.options.findIndex(function (option) {
        return option.value === _this.props.value;
      });
    });

    _this.state = {
      focusedIndex: _this.getSelectedOptionIndex()
    };
    return _this;
  }

  _createClass(SelectPopup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (this.state.focusedIndex !== prevState.focusedIndex) {
        this.ensureSelectedOptionVisibility();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.opened) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        ref: this.props.forwardedRef,
        className: classNames(styles['select-popup'], this.props.className)
      }, this.props.options.map(function (option, index) {
        var focused = _this2.state.focusedIndex === index;
        return /*#__PURE__*/React.createElement(SelectPopupOption, {
          key: option.value,
          forwardedRef: focused ? _this2.focusedOptionRef : undefined,
          option: option,
          index: index,
          multiple: _this2.props.multiple,
          focused: focused,
          selected: _this2.isSelectedOption(option),
          onClick: _this2.handleOptionClick,
          onMouseMove: _this2.handleMouseMoveOption
        });
      }));
    }
  }, {
    key: "ensureSelectedOptionVisibility",
    value: function ensureSelectedOptionVisibility() {
      var container = this.props.forwardedRef.current;
      var option = this.focusedOptionRef.current;

      if (container && option) {
        ensureChildrenVisibility(container, option);
      }
    }
  }]);

  return SelectPopup;
}(React.Component);